import { GetAppQr } from '~/components/ui/GetAppQr';
import { cn } from '~/lib/cn';
import { useContent } from '~/lib/useLanguage';

/**
 * "Download nsave" QR element (Figma Cards / Pay in a tap).
 * Row with a scannable QR (current origin + `/get-the-app`) on the left and a
 * bold label on the right. Desktop-only (hidden on small screens).
 */
export function DownloadQr({ className }: { className?: string }) {
  const { ui } = useContent();

  return (
    <div
      className={cn(
        'hidden items-center gap-5 rounded-none bg-white p-3 ring-1 ring-black-6 md:inline-flex',
        className,
      )}>
      <GetAppQr className="size-20 shrink-0" />
      <span className="pe-7 text-body font-semibold text-ink">{ui.downloadQr.label}</span>
    </div>
  );
}
